/**
 *
 * Question
 *
 */

import { mapMutations } from 'vuex';

export const QaQuestionUpdateMixin = {
  name: 'QaQuestionUpdateMixin',

  methods: {
    ...mapMutations('QA/Question', {
      mm_UPDATE_QA_QUESTION: 'UPDATE_QA_QUESTION',
      mm_UPDATE_QA_ANSWER: 'UPDATE_QA_ANSWER',
    }),

    updateObjQa(objQa, payload) {
      let updateObjQa;
      if (objQa.qaQuestionId) {
        updateObjQa = this.mm_UPDATE_QA_QUESTION;
      } else {
        updateObjQa = this.mm_UPDATE_QA_ANSWER;
      }
      updateObjQa({
        ...objQa,
        ...payload,
      });
    },
  },
};
